// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"CopyToClipboard_textWrapper_3CfO5"};